import React, { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import PetOwnerDashboard from './Pet Owner/Dashboard';
import PetOwnerUnpaidDashboard from './Pet Owner/UnpaidDashboard';
import AdminDashboard from './Admin/Dashboard';

const Dashboard = () => {
  const { roles, user } = useContext(UserContext); // Get the roles from context

  return (
    <div className="px-2 space-y-6">
      {roles.includes('admin') && <AdminDashboard />}

      {roles.includes('user') && (
        <>
          {user.paid ? <PetOwnerDashboard /> : <PetOwnerUnpaidDashboard />}
        </>
      )}
    </div>
  );
};

export default Dashboard;
